
/*============================================================================
product page click show
==============================================================================*/

$(document).ready(function() {
  
 $(".button_Decription__2").click(function() {
    
    $(".button_Decription_font__2").toggle(); //点击展开或隐藏文字
    
    if($(".button_Decription__2 img").hasClass("rotate")) { //点击箭头旋转180度

      $(".button_Decription__2 img").removeClass("rotate");

      $(".button_Decription__2 img").addClass("rotate1");

    } else {
      $(".button_Decription__2 img").removeClass("rotate1"); //再次点击箭头回来

      $(".button_Decription__2 img").addClass("rotate");
    }
  });
  $(".button_Decription__1").click(function() {
    
    $(".button_Decription_font__1").toggle(); //点击展开或隐藏文字
    
    if($(".button_Decription__1 img").hasClass("rotate")) { //点击箭头旋转180度

      $(".button_Decription__1 img").removeClass("rotate");

      $(".button_Decription__1 img").addClass("rotate1");

    } else {
      $(".button_Decription__1 img").removeClass("rotate1"); //再次点击箭头回来

      $(".button_Decription__1 img").addClass("rotate");
    }
  });
  $(".button_Decription").click(function() {
    console.log("qian");
    $(".button_Decription_font").toggle();
    console.log("hou");
    
    if($(".button_Decription img").hasClass("rotate")) { //点击箭头旋转180度

      $(".button_Decription img").removeClass("rotate");

      $(".button_Decription img").addClass("rotate1");

    } else {
      $(".button_Decription img").removeClass("rotate1"); //再次点击箭头回来

      $(".button_Decription img").addClass("rotate");
    }
  });
  $(".button_Decription_cleaning").click(function() {
    $(".button_Decription_cleaning_font").toggle();
    
    if($(".button_Decription_cleaning img").hasClass("rotate")) { //点击箭头旋转180度

      $(".button_Decription_cleaning img").removeClass("rotate");

      $(".button_Decription_cleaning img").addClass("rotate1");

    } else {
      $(".button_Decription_cleaning img").removeClass("rotate1"); //再次点击箭头回来

      $(".button_Decription_cleaning img").addClass("rotate");
    }
  });
  $(".button_Decription_shipping").click(function() {
    $(".button_Decription_shipping_font").toggle();
    
    if($(".button_Decription_shipping img").hasClass("rotate")) { //点击箭头旋转180度

      $(".button_Decription_shipping img").removeClass("rotate");

      $(".button_Decription_shipping img").addClass("rotate1");

    } else {
      $(".button_Decription_shipping img").removeClass("rotate1"); //再次点击箭头回来

      $(".button_Decription_shipping img").addClass("rotate");
    }
  });

  $(".button_Decription__Highlights").click(function() {
    
    $(".button_Decription_font__Highlights").toggle(); //点击展开或隐藏文字
    $(".button_Decription_font__Highlights_1").toggle();
    $(".button_Decription_font__Highlights_2").toggle();
    
    if($(".button_Decription__Highlights img").hasClass("rotate")) { //点击箭头旋转180度

      $(".button_Decription__Highlights img").removeClass("rotate");

      $(".button_Decription__Highlights img").addClass("rotate1");

    } else {
      $(".button_Decription__Highlights img").removeClass("rotate1"); //再次点击箭头回来

      $(".button_Decription__Highlights img").addClass("rotate");
    }
  });
  $(".button_Decription__Features").click(function() {
    
    $(".button_Decription_font__Features").toggle(); //点击展开或隐藏文字
    $(".button_Decription_font__Features_1").toggle();
    $(".button_Decription_font__Features_2").toggle();
    
    if($(".button_Decription__Features img").hasClass("rotate")) { //点击箭头旋转180度

      $(".button_Decription__Features img").removeClass("rotate");

      $(".button_Decription__Features img").addClass("rotate1");

    } else {
      $(".button_Decription__Features img").removeClass("rotate1"); //再次点击箭头回来

      $(".button_Decription__Features img").addClass("rotate");
    }
  });
  $(".button_Decription__Description").click(function() {
    $(".button_Decription_font__Description").toggle();
    $(".button_Decription_font__Description_1").toggle();
    $(".button_Decription_font__Description_2").toggle();
    
    if($(".button_Decription__Description img").hasClass("rotate")) { //点击箭头旋转180度

      $(".button_Decription__Description img").removeClass("rotate");

      $(".button_Decription__Description img").addClass("rotate1");

    } else {
      $(".button_Decription__Description img").removeClass("rotate1"); //再次点击箭头回来

      $(".button_Decription__Description img").addClass("rotate");
    }
  });
  $(".button_Decription__Materials").click(function() {
    $(".button_Decription_font__Materials").toggle();
    $(".button_Decription_font__Materials_1").toggle();
    $(".button_Decription_font__Materials_2").toggle();
    
    if($(".button_Decription__Materials img").hasClass("rotate")) { //点击箭头旋转180度

      $(".button_Decription__Materials img").removeClass("rotate");

      $(".button_Decription__Materials img").addClass("rotate1");

    } else {
      $(".button_Decription__Materials img").removeClass("rotate1"); //再次点击箭头回来

      $(".button_Decription__Materials img").addClass("rotate");
    }
  });
  $(".button_Decription__Care").click(function() {
    $(".button_Decription_font__Care").toggle();
    $(".button_Decription_font__Care_1").toggle();
    $(".button_Decription_font__Care_2").toggle();
    
    if($(".button_Decription__Care img").hasClass("rotate")) { //点击箭头旋转180度

      $(".button_Decription__Care img").removeClass("rotate");

      $(".button_Decription__Care img").addClass("rotate1");

    } else {
      $(".button_Decription__Care img").removeClass("rotate1"); //再次点击箭头回来

      $(".button_Decription__Care img").addClass("rotate");
    }
  });
  $(".button_Decription__Shipping").click(function() {
    $(".button_Decription_font__Shipping").toggle();
    $(".button_Decription_font__Shipping_1").toggle();
    $(".button_Decription_font__Shipping_2").toggle();
    
    if($(".button_Decription__Shipping img").hasClass("rotate")) { //点击箭头旋转180度

      $(".button_Decription__Shipping img").removeClass("rotate");

      $(".button_Decription__Shipping img").addClass("rotate1");

    } else {
      $(".button_Decription__Shipping img").removeClass("rotate1"); //再次点击箭头回来

      $(".button_Decription__Shipping img").addClass("rotate");
    }
  })

  $(".inner-chain-title").click(function() {
    $(this).next(".inner-chain-item").toggle();

    if ($(this).find("img").hasClass("rotate")) {
      $(this).find("img").removeClass("rotate").addClass("rotate1");
    } else {
      $(this).find("img").removeClass("rotate1").addClass("rotate");
    }
  });
});



